import { ChevronLeftIcon, Drawer, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { formatDateWithTime, formatPhoneNumber } from '@/helpers'
import { useAIConversationDetail } from '@/services'

import {
  AgentJtbd,
  GeneralNotes,
  GeneralJtbd,
  LeadQualifierData,
  LeadQualifierScoring,
  ValidConversation,
} from './components'

import { variations } from './drawer-show.constants'

import styles from './drawer-show.module.css'

import { ConversationDrawerShowProps } from './drawer-show.type'

export const ConversationDrawerShow = ({
  isOpen,
  onHandleOpen,
  uuid,
  variation,
}: ConversationDrawerShowProps) => {
  const { t } = useTranslation('screenAiCenter')

  const { data: conversation } = useAIConversationDetail(uuid)

  const { extraData, createdBy, createdAt } = conversation?.data || {}
  const { evaluation } = extraData || {}

  const leadQualifier = extraData?.leadQualifier

  const components = {
    'valid-conversation': <ValidConversation evaluation={evaluation} />,
    'general-notes': (
      <div className={styles.card}>
        <Text variant="title-medium" className={styles['section-title']}>
          {t('conversationShowGeneralNotesTitle')}
        </Text>
        <GeneralNotes evaluation={evaluation} visualizationType="progress" />
      </div>
    ),
    'general-jtbd': (
      <div className={styles.card}>
        <Text variant="title-medium" className={styles['section-title']}>
          {t('conversationShowGeneralJtbdTitle')}
        </Text>
        <GeneralJtbd evaluation={evaluation} />
      </div>
    ),
    'agent-jtbd': (
      <div className={styles.card}>
        <Text variant="title-medium" className={styles['section-title']}>
          {t('conversationShowAgentJtbdTitle')}
        </Text>
        <AgentJtbd evaluation={evaluation} />
      </div>
    ),
    'lead-qualifier-scoring': (
      <div className={styles.card}>
        <Text variant="title-medium" className={styles['section-title']}>
          {t('conversationShowLeadQualifierScoringTitle')}
        </Text>
        <LeadQualifierScoring data={extraData?.leadQualifier} />
      </div>
    ),
    'lead-qualifier-data': (
      <div className={styles.card}>
        <Text variant="title-medium" className={styles['section-title']}>
          {t('conversationShowLeadQualifierTitle')}
        </Text>
        <LeadQualifierData leadQualifier={leadQualifier} />
      </div>
    ),
  }

  const render = () => {
    return variations?.[variation]?.map((component) => components?.[component])
  }

  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <header className={styles.header}>
        <button
          type="button"
          onClick={onHandleOpen}
          className={styles['header-button']}
        >
          <ChevronLeftIcon />
        </button>

        <div className={styles['header-box-content']}>
          <Text className={styles['header-title']} variant="text-large-bold">
            {t('conversationShowHeaderTitle')}
            {createdAt ? formatDateWithTime(createdAt, 'es-MX') : '-'}
          </Text>

          <Text className={styles['header-subtitle']}>
            {t('conversationShowHeaderSubtitle')}
            <Text variant="title-base">
              {createdBy ? formatPhoneNumber(createdBy, 'es-MX') : '-'}
            </Text>
          </Text>
        </div>
      </header>

      <div className={styles.core}>{render()}</div>
    </Drawer>
  )
}
